import { render, staticRenderFns } from "./DlgFileNew.vue?vue&type=template&id=357abb21&scoped=true&"
import script from "./DlgFileNew.vue?vue&type=script&lang=ts&"
export * from "./DlgFileNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357abb21",
  null
  
)

export default component.exports